//enum for WorkItemTabType Ids
export enum WorkItemTabTypes
{
    General = "D9C2F748-1A8D-4112-B487-8D86EFC31DBB",
    UniversalField = "564FB9BB-92C6-4C8D-AB7C-01FCD4C4F699"
}